module.exports = __webpack_public_path__ + "img/25.20fbcf69.jpg";